<template>
  <div
    id="app_inner"
    :class="[
      isIE ? 'isIE' : '',
      isPageLoading ? 'isPageLoading' : '',
      isShowContent ? 'isShowContent' : '',
    ]"
  >
    <loading-mask
      :data="this.rowData"
      :loadingPercent="this.loadingPercent"
      :bgBlur="this.bgBlur"
    ></loading-mask>
    <header-component
      :data="this.rowData"
      :is-show-content="this.isShowContent"
      :is-header-fixed="this.isHeaderFixed"
      :on-header-leave="this.onHeaderLeave"
    ></header-component>
    <main-component
      :data="this.rowData"
      :is-page-loading="this.isPageLoading"
    ></main-component>
  </div>
</template>

<script>
import LoadingMask from "./LoadingMask";
import HeaderComponent from "./HeaderComponent";
import MainComponent from "./MainComponent";
import json from "/jsons/data.json";

export default {
  name: "IndexComponent",
  components: {
    LoadingMask,
    HeaderComponent,
    MainComponent,
  },
  props: {},
  data() {
    return {
      isPageLoading: true,
      loadingPercent: 0,
      bgBlur: 10,
      isMenuOpen: false,
      isIE: false,
      isShowContent: false,
      isHeaderFixed: false,
      onHeaderLeave: false,
      rowData: json,
    };
  },
  methods: {
    handleScroll() {
      let isTransitionRunning = null;
      if (window.scrollY == 0) {
        this.isShowContent = false;
        this.onHeaderLeave = true;
        document.body.classList.remove("onPageTransition");

        //  scroll while transion is running
        clearTimeout(isTransitionRunning);

        // remove header on leave status
        setTimeout(
          function (scope) {
            scope.onHeaderLeave = false;
          },
          300,
          this
        );

        // remove header fixed
        this.isHeaderFixed = false;
      } else {
        if (!this.isShowContent) {
          document.body.classList.add("onPageTransition");

          // prevent scroll while transion is running
          clearTimeout(isTransitionRunning);
          isTransitionRunning = setTimeout(() => {
            document.body.classList.remove("onPageTransition");
          }, 1800);

          this.isShowContent = true;

          // delay 500ms to fixed header on top (waiting for transition)
          setTimeout(
            function (scope) {
              scope.isHeaderFixed = true;
            },
            500,
            this
          );

          setTimeout(function() {
              window.scrollTo(0, 1);
          },100);
        }
      }
    },

    debounce(func, delay = 250) {
      let timer = null;

      return () => {
        let context = this;
        let args = arguments;

        clearTimeout(timer);
        timer = setTimeout(() => {
          func.apply(context, args);
        }, delay);
      };
    },

    randomSeconds(min, max) {
      let rand = Math.floor(Math.random() * (max - min + 1) + min) * 10;
      return rand;
    },

    percentNumCountDown() {
      let current = 0;
      let total = 100;
      let blurMax = 10;
      let blurMin = 0;

      let countDownTimer = setInterval(
        function (scope) {
          if (current == total) {
            scope.loadingPercent = current;
            scope.bgBlur = blurMin;
            scope.isPageLoading = false;
            clearInterval(countDownTimer);
          } else {
            current++;
            scope.loadingPercent = current;
            scope.bgBlur = ((total - current) * (blurMax - blurMin)) / total + blurMin;
          }
        },
        this.randomSeconds(3, 4),
        this
      );
    },
  },
  mounted() {
    // document.title = "Semiconductor";
    window.onload = function () {
      window.scrollTo(0, 0);
    }

    // detect IE
    let ua = window.navigator.userAgent;
    if (ua.indexOf("MSIE") != -1) {
      this.isIE = true;
    }

    // detect scroll
    window.addEventListener("scroll", this.handleScroll);

    // loading mask
    this.percentNumCountDown();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "~bootstrap/scss/bootstrap";
@import "@/assets/styles/libs.scss";
@import "@/assets/styles/base.scss";
</style>
